import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-scroll'
import { Link as LinkPage } from 'gatsby'
import { useSelector } from 'react-redux'
import { useGeneralNavigationQuery } from '../../hooks/useGeneralNavigationQuery'
import useContent from '../../utils/content'

const GeneralNavigation = ({ displayMenu }) => {
  const state = useSelector(props => props)
  const content = useContent(useGeneralNavigationQuery())

  return (
    <div
      className={`navigation_menu navigation_menu--${
        displayMenu ? 'active' : 'disabled'
      }`}
    >
      <div className="navigation_menu_list">
        {content.list.map(data => {
          return (
            <Link
              key={Math.random()}
              to={data.src}
              smooth
              spy
              offset={0}
              duration={600}
              activeClass="active"
              className="navigation_menu_list_link"
            >
              {data.item}
            </Link>
          )
        })}
      </div>
      <div className="navigation_menu_language">
        <LinkPage
          to="/en"
          className={`navigation_menu_language_link ${
            state.languageValue !== 'uk'
              ? 'navigation_menu_language_link_active'
              : ''
          }`}
        >
          ENG
        </LinkPage>
        <p className="navigation_menu_language_link navigation_menu_language_link-between">
          &nbsp;|&nbsp;
        </p>
        <LinkPage
          to="/"
          className={`navigation_menu_language_link ${
            state.languageValue === 'uk'
              ? 'navigation_menu_language_link_active'
              : ''
          }`}
        >
          UKR
        </LinkPage>
      </div>
    </div>
  )
}

GeneralNavigation.propTypes = {
  displayMenu: PropTypes.bool
}

GeneralNavigation.defaultProps = {
  displayMenu: true
}

export default GeneralNavigation
